import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";

import Breadcrumbs from "../../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import BackBtn from "../../../../components/Common/backBtn";
import InputRadioField from "../../../../components/Common/inputRadioField";
import InputTextField from "../../../../components/Common/inputTextField";
import SucessModal from "../../../../components/Modal/SucessModal";

const InclinicSpecializationForm = ({ edit = false, view = false }) => {
  const { id } = useParams();

  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useForm();

  const [success, setSuccess] = useState(false);

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}inclinic-specialization/get/${id}`)
      .then((response) => {
        setValue("active", response.data.active);
        setValue("inc_specialization", response.data.inc_specialization);
        trigger();
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    (view || edit) && getMenuData();
  }, [edit]);

  const onSubmit = (fields) => {
    if (edit) {
      axios
        .patch(
          `${process.env.REACT_APP_API_URL}inclinic-specialization/update/${id}`,
          fields,
        )
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    } else {
      axios
        .post(
          `${process.env.REACT_APP_API_URL}inclinic-specialization/create`,
          fields,
        )
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    }
  };

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Doctor",
        link: "/add-new-doctors",
      },
      {
        text: "Common Heads",
        link: "/inclinic-specializations",
      },
      {
        text: "Inclinic Specialization",
        link: "/inclinic-specializations",
      },
      {
        text: edit
          ? "Edit Inclinic Specialization"
          : view
            ? "View Inclinic Specialization"
            : "Add new Inclinic Specialization",
        link: "",
      },
    ],
    [],
  );

  return (
    <>
      <Breadcrumbs
        className="w-100 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      <BackBtn navigatePath="/inclinic-specializations" />
      <div className="healtharticle mt-5">
        {/* <div className="pt-3 ms-3">
          <Breadcrumbs
            breadcrumbText="Doctor"
            breadcrumbLink="/add-new-doctors"
            nestedText="Common Heads"
            nestedLink=""
            nestedText2="Inclinic Specialization"
            nestedLink2=""
            nestedText3={edit ? "Edit Inclinic Specialization" : "Add new Inclinic Specialization"}
            nestedLink3=""
          />
        </div> */}
        <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
          <div className="row car-dep-form">
            <div className="col-5">
              <InputTextField
                register={register}
                errors={errors}
                labelName="Inclinic Specialization"
                errorText="Please enter the Inclinic Specialization type."
                name="inc_specialization"
                placeholder="Type here..."
                view={view}
              />
            </div>

            <div className="col-3">
              <InputRadioField
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                disabled={view}
              />
            </div>
          </div>

          {!view && (
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          )}
        </form>
      </div>
      {/* </Home> */}
      {success && (
        <SucessModal
          page={"/inclinic-specializations"}
          name="new inclinic specialization"
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );
};

export default InclinicSpecializationForm;
